"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useSendBoxValue;

var _WebChatReduxContext = require("./internal/WebChatReduxContext");

var _useWebChatAPIContext = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useSendBoxValue() {
  return [(0, _WebChatReduxContext.useSelector)(function (_ref) {
    var sendBoxValue = _ref.sendBoxValue;
    return sendBoxValue;
  }), (0, _useWebChatAPIContext.default)().setSendBox];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VTZW5kQm94VmFsdWUudHMiXSwibmFtZXMiOlsidXNlU2VuZEJveFZhbHVlIiwic2VuZEJveFZhbHVlIiwic2V0U2VuZEJveCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOztBQUNBOzs7O0FBRWUsU0FBU0EsZUFBVCxHQUE4RDtBQUMzRSxTQUFPLENBQUMsc0NBQVk7QUFBQSxRQUFHQyxZQUFILFFBQUdBLFlBQUg7QUFBQSxXQUFzQkEsWUFBdEI7QUFBQSxHQUFaLENBQUQsRUFBa0QscUNBQXVCQyxVQUF6RSxDQUFQO0FBQ0QiLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IHVzZVNlbGVjdG9yIH0gZnJvbSAnLi9pbnRlcm5hbC9XZWJDaGF0UmVkdXhDb250ZXh0JztcbmltcG9ydCB1c2VXZWJDaGF0QVBJQ29udGV4dCBmcm9tICcuL2ludGVybmFsL3VzZVdlYkNoYXRBUElDb250ZXh0JztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlU2VuZEJveFZhbHVlKCk6IFtzdHJpbmcsICh2YWx1ZTogc3RyaW5nKSA9PiB2b2lkXSB7XG4gIHJldHVybiBbdXNlU2VsZWN0b3IoKHsgc2VuZEJveFZhbHVlIH0pID0+IHNlbmRCb3hWYWx1ZSksIHVzZVdlYkNoYXRBUElDb250ZXh0KCkuc2V0U2VuZEJveF07XG59XG4iXX0=